const FALLBACK_DEMO_VIDEO_URL = '/demo.mp4';

export function getDemoVideoUrl() {
  try {
    return (
      (typeof import.meta !== 'undefined' &&
        import.meta.env &&
        import.meta.env.VITE_DEMO_VIDEO_URL) ||
      FALLBACK_DEMO_VIDEO_URL
    );
  } catch {
    return FALLBACK_DEMO_VIDEO_URL;
  }
}

function extractYouTubeId(url) {
  const match = String(url).match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i
  );
  return match?.[1] || null;
}

function extractVimeoId(url) {
  const match = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  return match?.[1] || null;
}

export function getVideoEmbedConfig(url, autoPlay = false) {
  const cleanUrl = String(url || '').trim() || FALLBACK_DEMO_VIDEO_URL;
  const autoPlayParam = autoPlay ? '1' : '0';

  const youTubeId = extractYouTubeId(cleanUrl);
  if (youTubeId) {
    return {
      type: 'iframe',
      embedUrl: `https://www.youtube.com/embed/${youTubeId}?autoplay=${autoPlayParam}&rel=0&modestbranding=1`,
    };
  }

  const vimeoId = extractVimeoId(cleanUrl);
  if (vimeoId) {
    return {
      type: 'iframe',
      embedUrl: `https://player.vimeo.com/video/${vimeoId}?autoplay=${autoPlayParam}&title=0&byline=0&portrait=0`,
    };
  }

  return {
    type: 'video',
    sourceUrl: cleanUrl,
  };
}
